import React, { useState, useEffect, useContext } from 'react';
import { Container, Grid, TextField, Checkbox, FormControlLabel } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { AccountRating, AccountType, AccountIndustry, AccountOwnership } from '../../../utils/enums'
import UsersAutoComplete from '../../Users/UsersAutoComplete';
import { AuthContext } from '../../../context/AuthContext';

const CreateForm = ({ onSubmit }) => {
    const { userId } = useContext(AuthContext);
    const [ownerId, setOwnerId] = useState(userId || '');
    const [accountName, setAccountName] = useState('');
    const [fax, setFax] = useState(null);
    
    const [accountSite, setAccountSite] = useState(null);
    const [website, setWebsite] = useState(null);
    const [accountType, setAccountType] = useState(0);
    const [accountNumber, setAccountNumber] = useState(null);
    const [industry, setIndustry] = useState(0);
    const [annualRevenue, setAnnualRevenue] = useState(0);    
    const [rating, setRating] = useState(0);
    const [phone, setPhone] = useState(null);
    const [parentAccountId, setParentAccountId] = useState(null);
    const [tickerSymbol, setTickerSymbol] = useState(null);
    const [ownership, setOwnership] = useState(0);
    const [employees, setEmployees] = useState(null);
    const [sicCode, setSicCode] = useState(null);

    const [billingStreet, setBillingStreet] = useState(null);
    const [billingCity, setBillingCity] = useState(null);
    const [billingState, setBillingState] = useState(null);
    const [billingCode, setBillingCode] = useState(null);
    const [billingCountry, setBillingCountry] = useState(null);
    
    const [shippingStreet, setShippingStreet] = useState(null);
    const [shippingCity, setShippingCity] = useState(null);
    const [shippingState, setShippingState] = useState(null);
    const [shippingCode, setShippingCode] = useState(null);
    const [shippingCountry, setShippingCountry] = useState(null);

    const [description, setDescription] = useState(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        // Collect all form data
        const formData = {
            ownerId,
            accountName,
            fax,
            accountSite,
            website,
            accountType,
            accountNumber,
            industry,
            annualRevenue,
            rating,
            phone,
            parentAccountId,
            tickerSymbol,
            ownership,
            employees,
            sicCode,
            billingStreet,
            billingCity,
            billingState,
            billingCode,
            billingCountry,
            shippingStreet,
            shippingCity,
            shippingState,
            shippingCode,
            shippingCountry,
            description
          };
        // Call onSubmit function passed as a prop
        onSubmit(formData);
    };

    useEffect(() => {
        if (userId) {
            setOwnerId(userId);
        }
    }, [userId]);

    return (
        <form id='create-form' onSubmit={handleSubmit}>
        <Container maxWidth="md" sx={{ marginTop: "10px" }}>
            <h4>Account Information</h4>
            <Grid container spacing={3}>
                {/* Account Owner */}
                <Grid item xs={12} sm={6}>
                    <UsersAutoComplete userId={userId} setUserId={setOwnerId} />
                </Grid>

                {/* Rating ****** */}
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        disablePortal
                        options={AccountRating}
                        sx={{ width: "100%" }}
                        value={AccountRating.find((option) => option.value === 0)}
                        onChange={(event, newValue) => setRating(newValue ? newValue.value : '')}
                        renderInput={(params) => <TextField {...params} label="Rating" />}
                    />
                </Grid>

                {/* Account Name */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Account Name" required 
                    onChange={(e) => setAccountName(e.target.value)} />
                </Grid>

                {/* Phone */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Phone"  
                    onChange={(e) => setPhone(e.target.value)}/>
                </Grid>

                {/* Fax */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Fax"
                    onChange={(e) => setFax(e.target.value)} />
                </Grid>

                {/* Parent Account ****** */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Parent Account"
                    onChange={(e) => setFax(e.target.value)} />
                </Grid>

                {/* Account Site */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Account Site"
                    onChange={(e) => setAccountSite(e.target.value)} />
                </Grid>

                {/* Ticker Symbol */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Ticker Symbol"
                    onChange={(e) => setTickerSymbol(e.target.value)} />
                </Grid>

                {/* Website */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Website"
                    onChange={(e) => setWebsite(e.target.value)} />
                </Grid>

                {/* Ownership ****** */}
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        disablePortal
                        options={AccountOwnership}
                        sx={{ width: "100%" }}
                        value={AccountOwnership.find((option) => option.value === 0)}
                        onChange={(event, newValue) => setOwnership(newValue ? newValue.value : '')}
                        renderInput={(params) => <TextField {...params} label="Ownership" />}
                    />
                </Grid>

                {/* Account Type ****** */}
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        disablePortal
                        options={AccountType}
                        sx={{ width: "100%" }}
                        value={AccountType.find((option) => option.value === 0)}
                        onChange={(event, newValue) => setAccountType(newValue ? newValue.value : '')}
                        renderInput={(params) => <TextField {...params} label="Account Type" />}
                    />
                </Grid>

                {/* Employees */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Employees"
                    onChange={(e) => setEmployees(e.target.value)} />
                </Grid>

                {/* Account Number */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Account Number"
                    onChange={(e) => setAccountNumber(e.target.value)} />
                </Grid>

                {/* SIC Code */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Skype ID"
                    onChange={(e) => setSicCode(e.target.value)} />
                </Grid>

                {/* Industry */}
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        disablePortal
                        options={AccountIndustry}
                        sx={{ width: "100%" }}
                        value={AccountIndustry.find((option) => option.value === 0)}
                        onChange={(event, newValue) => setIndustry(newValue ? newValue.value : '')}
                        renderInput={(params) => <TextField {...params} label="Industry" />}
                    />
                </Grid>

                {/* Annual Revenue */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Annual Revenue" 
                    onChange={(e) => setAnnualRevenue(e.target.value)} />
                </Grid>
            </Grid >
            <br />
            <h4>Address Information</h4>
            <Grid container spacing={3}>
                {/* Billing Street */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Billing Street"
                    onChange={(e) => setBillingStreet(e.target.value)} />
                </Grid>

                {/* Shipping Street  */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Shipping Street "
                    onChange={(e) => setShippingStreet(e.target.value)} />
                </Grid>

                {/* Billing City */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Billing City"
                    onChange={(e) => setBillingCity(e.target.value)} />
                </Grid>

                {/* Shipping City */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Shipping City"
                    onChange={(e) => setShippingCity(e.target.value)} />
                </Grid>

                {/* Billing State */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Billing State"
                    onChange={(e) => setBillingState(e.target.value)} />
                </Grid>
                {/* Shipping State */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Shipping State"
                    onChange={(e) => setShippingState(e.target.value)} />
                </Grid>

                {/* Billing Code */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Billing Code"
                    onChange={(e) => setBillingCode(e.target.value)} />
                </Grid>
                {/* Shipping Code */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Shipping Code"
                    onChange={(e) => setShippingCode(e.target.value)} />
                </Grid>

                {/* Billing Country */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Billing Country"
                    onChange={(e) => setBillingCountry(e.target.value)} />
                </Grid>
                {/* Shipping Country */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Shipping Country"
                    onChange={(e) => setShippingCountry(e.target.value)} />
                </Grid>
            </Grid >
            <br />
            <h4>Description Information</h4>
            <Grid container spacing={3}>
                {/* Description */}
                <Grid item xs={12} sm={12}>
                    <TextField multiline fullWidth label="Description"
                    onChange={(e) => setDescription(e.target.value)} />
                </Grid>
            </Grid >
        </Container >
        </form>
    );
};

export default CreateForm;
